import { render, staticRenderFns } from "./ConflictedUsersDialog.vue?vue&type=template&id=1fa44015&scoped=true"
import script from "./ConflictedUsersDialog.vue?vue&type=script&lang=js"
export * from "./ConflictedUsersDialog.vue?vue&type=script&lang=js"
import style0 from "./ConflictedUsersDialog.vue?vue&type=style&index=0&id=1fa44015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa44015",
  null
  
)

export default component.exports